import { render, staticRenderFns } from "./DependenciesReport.vue?vue&type=template&id=a696c914&"
import script from "./DependenciesReport.vue?vue&type=script&lang=js&"
export * from "./DependenciesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports